<template>
	<div id="dynamic">
		<div class="banner">
			<img :src="pageData.article_topbanner" class="pic">
		</div>
		<breadcrumb/>
		<div class="news widthBox">
			<h4 class="m_title hidden-sm-and-up" v-if="pageData.navmsg">{{pageData.navmsg.name}}</h4>
			<div class="title acea-row row-between-wrapper">
				<span class="hidden-xs-only" v-if="pageData.navmsg">{{pageData.navmsg.name}}</span>
				<div class="search acea-row row-middle">
					<i @click="keywordChange" class="iconfont icon-sousuo"></i>
					<span></span>
					<input v-model="keyword" type="text" />
				</div>
			</div>
			<div class="hot">
				<template v-for="(item,index) in pageData.hotsearchtitle">
					<template v-if="index > 0">
						|
					</template>
					<span @click="keywordChange" :data-keyword="item.title">
						<!-- <img src="@/assets/icon_11.png" class="icon" alt=""> -->
						{{item.title}}
					</span>
				</template>
			</div>
			<div class="list">
				<ul v-if="articlelist.length > 0">
					<li @click="toDetail(item.id)" v-for="item in articlelist">
						<div class="time">{{item.date}}</div>
						<h4 class="lineOne">{{item.title}}</h4>
						<p>{{item.describe}}</p>
					</li>
				</ul>
				<div class="listNo" v-else>
					- 暂无更多 -
				</div>
				<div style="margin-top:40px;">
					<pagination :total="total" @getPage="getPage" :current-page="page" :page-size="7" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import breadcrumb from '@/components/breadcrumb.vue'
	import pagination from '@/components/pagination.vue'
	import pageTitle from '@/components/pageTitle.vue'
import metaInfo from "@/utils/metaInfo.js";
export default {
	metaInfo,
	  name: 'knowledge',
	  components: { breadcrumb,pagination,pageTitle },
	  data:function(){
	  	  return{
	  			  pageData:{},
				  page:1,
				  keyword:'',
				  id:'',
				  articlelist:[],
				  total:0
	  	  }
	  },
	  created() {
		this.keyword = this.$route.query.keyword,
		this.id = this.$route.query.id,
	  	this.getData()
	  },
	  methods:{
		  getPage(e){
			  this.articlelist = []
			  this.page = e
			  this.getData()
		  },
		  toDetail(e){
			this.$router.push({path:'/detail', query:{id:e}});
		  },
		  keywordChange(e){
			  var keyword = e.currentTarget.dataset.keyword
			  if(keyword){
				  this.keyword=keyword
			  }
			  if(this.keyword){
				  this.page = 1
				  this.articlelist = []
				  this.getData()
			  }
		  },
		  getData(){
			this.$api.post('home/Index/articlethree', {
				keyword:this.keyword,
				page:this.page,
				id:this.id,
			}).then(res => {
				this.pageData = res.data
				this.articlelist = res.data.articlelist
				this.total = res.data.total
			})
		  },
	  },
	}
</script>

<style lang="scss">
	#dynamic{
		background:#FAF9F9;
		.banner{
			img{
				width:100%;
			}
		}
		.listNo{
			text-align: center;
			line-height:100px;
			font-size:16px;
			color:#999;
			background:#FFF;
		}
		.news{
			padding:82px 0 0 0;
			.title{
				span{
					font-size:34px;
					color:#124098;
					font-weight: bold;
					line-height:50px;
				}
				.search{
					height: 50px;
					border: 1px solid #dcdbdb;
					border-radius: 100px;
					display: block;
					overflow: hidden;
					input{
						width:calc(100% - 61px);
						height:50px;
						border:0;
						box-sizing: border-box;
						padding:0 10px;
						background:none;
					}
					span{
						width:1px;
						height:20px;
						display:inline-block;
						vertical-align: middle;
						background:#E5E5E5;
					}
					.iconfont{
						width:24px;
						height:24px;
						font-size:24px;
						color:#999;
						padding:13px 15px 13px 20px;
						vertical-align: middle;
					}
				}
			}
			.hot{
				font-size:18px;
				line-height:24px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				margin-top:12px;
				span{
					line-height:24px;
					font-size:16px;
					display: inline-block;
					width:230px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					margin:0 14px;
					vertical-align: middle;
					cursor: pointer;
					&:first-child{
						margin-left:0;
					}
					&:hover{
						color:#124098;
					}
					.icon{
						width:24px;
						height:24px;
						vertical-align: middle;
					}
				}
			}
			.list{
				padding-bottom:40px;
				margin-top:31px;
				li{
					background:#FFF;
					padding:30px;
					box-sizing: border-box;
					margin-top:24px;
					cursor: pointer;
					&:first-child{
						margin-top:0;
					}
					.time{
						font-size:16px;
						color:#124098;
						line-height:22px;
					}
					h4{
						font-size:20px;
						margin-top:8px;
						line-height:28px;
						color:#333;
					}
					p{
						margin-top:8px;
						font-size:16px;
						line-height:28px;
					}
				}
			}
		}
	}
	
	@media screen and(max-width:768px) {
		#dynamic{
			.news{
				padding-top:20px;
				.m_title{
					text-align: center;
					color:#124098;
					font-size:16px;
					line-height:32px;
				}
				 .title{
					 span{
						 display: block;
					 }
					 .search{
						 width:calc(100% - 40px);
						 box-sizing: border-box;
						 margin:10px 20px 0;
						 height:40px;
						 .iconfont{
							 padding:8px 15px;
							 line-height:40px;
						 }
						input{
							height:40px;
						}
					 }
				 }
				 .hot{
					 margin:10px 20px 0;
					 span{
						 font-size:14px;
						 margin:5px;
					 }
				 }
				 .list{
					 margin-top:20px;
					 li{
						 margin:20px 20px 0;
						 padding:15px 20px;
						 position: relative;
						.time{
							font-size:16px;
						}
						h4{
							font-size:16px;
						}
						p{
							font-size:14px;
							margin-top:0;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					 }
				 }
			}
		}
	}
</style>
